<template>
    <div class="comment">
        <div class="comment-header">
            <div class="comment-title">
                {{$t("评论")}}
            </div>
        </div>

        <van-list
            v-model:loading="loading"
            :finished="finished"
            loading-text="Loading..."
            @load="onLoad"
        >
            <div class="comment-list">
                <div class="comment-item" v-for="comment in commentList" :key="comment.id">
                    <div class="comment-user">
                        <router-link :to="`/user/${comment.user.id}`" class="user-left">
                            <div class="avatar">
                                <img :src="util.thumb(comment.user.avatar, 180)">
                            </div>
                            <span class="name">{{comment.user.name}}</span>
                            <span class="author" v-if="comment.user.id == userId">{{$t('作者')}}</span>
                        </router-link>

                        <div class="comment-like"
                            @click="downloadApp">
                            <i class="iconfont icon-like"></i>
                            <span class="num">{{comment.likeNum}}</span>
                        </div>
                    </div>
                    <div class="comment-content">
                        <div class="content">
                            <span class="text">{{comment.content}}</span>
                            <span class="time">&nbsp;&nbsp;{{comment.create}}</span>
                        </div>
                        
                        <div class="comment-item" v-for="comment in comment.children" :key="comment.id">
                            <div class="comment-user">
                                <router-link :to="`/user/${comment.user.id}`" class="user-left">
                                    <div class="avatar">
                                        <img :src="util.thumb(comment.user.avatar, 180)">
                                    </div>
                                    <span class="name">{{comment.user.name}}</span>
                                    <span class="author" v-if="comment.user.id == userId">{{$t('作者')}}</span>
                                    <span class="reply-txt" v-if="comment.otherUserId">{{$t('回复')}}</span>
                                    <span class="reply-name" v-if="comment.otherUserId">{{comment.otherUser.name}}</span>
                                </router-link>

                                <div class="comment-like"
                                    @click="downloadApp">
                                    <i class="iconfont icon-like"></i>
                                    <span class="num">{{comment.likeNum}}</span>
                                </div>
                            </div>
                            <div class="comment-content">
                                <div class="content">
                                    <span class="text">{{comment.content}}</span>
                                    <span class="time">&nbsp;&nbsp;{{comment.create}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <van-divider v-if="commentList.length === 0"> · </van-divider>
            </div>
        </van-list>

        
    </div>
</template>

<script>
import { List, Divider } from 'vant';

import api from "@/api/index";

export default {
    components: {
        VanList: List,
        VanDivider: Divider,
    },
    props: {
        id: {
            type: String,
        },
        userId: {
            type: String
        },
        // 类型 1：lifestyle 3二手
        type: {
            type: String
        }
    },
    data() {
        return {
            pn: 0,
            ps: 10,
            loading: false,
            finished: false,
            commentList: []
        };
    },
    mounted(){

    },
    methods: {
        // 加载
        onLoad(){
            if (this.finished) {
                return false;
            }
            this.pn++;
            this.getCommentList();
        },
        getCommentList(){
            if (!this.id) return
            let params = {
                objId: this.id,
                type: 1, // 类型 1：lifestyle 3二手
                pn: this.pn,
                ps: this.ps,
                lang: 1,
            }
            api.comment.get(params).then((res) => {
                let data = res.data.list;
                this.commentList = this.commentList.concat(data);

                if (data.length < this.ps) {
                    this.finished = true;
                }
                
                this.loading = false;
            })
        },
        downloadApp(){
            if (this.type == 1) {
                this.$downloadApp('subjectDetail', {subjectId: this.id});
            }else if (this.type == 3) {
                this.$downloadApp('usedDetail', {usedId: this.id});
            }
        }
    }
};
</script>

<style scoped>
.comment {
    padding: 0 15px;
    background-color: #ffffff;
    border-radius: 15px;
}
.comment .comment-header {
    display: flex;
    align-items: center;
    padding: 15px 0 5px 0;
    justify-content: space-between;
}
.comment .comment-header .comment-title {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
}

.comment .comment-list {
    overflow: hidden;
}
.comment .comment-item {
    padding: 10px 0 0 0;
    border-bottom: 1px solid #f3f3f3;
}
.comment .comment-item:last-child {
    padding-bottom: 10px;
    border-bottom: none;
}
.comment .comment-user {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.comment .comment-user .user-left{
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.comment .comment-user .avatar{
    width: 28px;
    height: 28px;
    margin-right: 6px;
}
.comment .comment-user .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 3px;
}
.comment .comment-user .name{
    font-size: 14px;
    line-height: 20px;
    color: #666666;
    margin-right: 4px;
}
.comment .comment-user .author{
    display: flex;
    align-items: center;
    padding: 0 7px;
    height: 23px;
    border: 1px solid rgba(17, 17, 17, 0.03);
    box-sizing: border-box;
    border-radius: 6px;
    font-size: 12px;
    color: #666666;
}
.comment .reply-txt{
    font-size: 14px;
    color: #111111;
    margin: 0 6px;
}
.comment .reply-name{
    font-size: 14px;
    color: #666666;
}
.comment .comment-like {
    display: flex;
    align-items: center;
}
.comment .comment-like .iconfont {
    margin-right: 4px;
    font-size: 13px;
    color: #111111;
}
.comment .comment-like .num{
    font-size: 14px;
    color: #111111;
}

.comment .comment-content {
    padding: 6px 0 6px 34px;
}
.comment .comment-content .text{
    display: inline;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}
.comment .comment-content .text a {
    display: inline;
    color: #2DB6B5;
    text-decoration: underline;
}
.comment .comment-content .time{
    display: inline-block;
    font-size: 12px;
    color: #666666;
}
</style>
